import React from "react";
import Errors from "@morningtrain/react-errors";
import useTemplateManager from "../hooks/use-template-manager";

function RenderCurrentTemplate(props) {

    const templateManager = useTemplateManager();

    const [template, setTemplate] = React.useState(null);

    const handleOnTemplateChange = nextTemplate => {
        setTemplate(nextTemplate);
    };

    React.useEffect(() => {

        if(template !== templateManager.currentTemplate) {
            setTemplate(templateManager.currentTemplate);
        }

        templateManager.onTemplateChange(handleOnTemplateChange);

        return () => {
            templateManager.removeOnTemplateChangeListener(handleOnTemplateChange);
        }
    }, []);

    if(template === null) {
        return (
            <Errors.Boundary>
                {props.children}
            </Errors.Boundary>
        );
    }

    const {templates} = templateManager;

    if (!templates[template]) {
        throw new Error(`Tried to render ${template} template, but it seems to be missing.`);
    }

    const CurrentTemplate = templates[template];

    return (
        <CurrentTemplate>
            <Errors.Boundary>
                {props.children}
            </Errors.Boundary>
        </CurrentTemplate>
    );
}

export default RenderCurrentTemplate;
